var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_1501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3569 15.7141C10.3569 14.5322 11.3179 13.5713 12.4998 13.5713H21.0712C22.2531 13.5713 23.2141 14.5322 23.2141 15.7141V24.2856C23.2141 25.4675 22.2531 26.4284 21.0712 26.4284H12.4998C11.3179 26.4284 10.3569 25.4675 10.3569 24.2856V15.7141ZM29.0768 14.7699C29.425 14.9574 29.6426 15.3191 29.6426 15.7141V24.2856C29.6426 24.6807 29.425 25.0423 29.0768 25.2298C28.7286 25.4173 28.3067 25.3972 27.9752 25.1762L24.761 23.0333L24.2855 22.7153V22.1427V17.857V17.2845L24.761 16.9664L27.9752 14.8235C28.3034 14.6059 28.7252 14.5824 29.0768 14.7699Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_1501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2857,
    height: 17.1429,
    fill: "white",
    transform: "translate(10.3569 11.4287)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideo);
export default __webpack_public_path__ + "static/media/ic_video.0f6735ffcd8a99a2d434821e1194ab02.svg";
export { ForwardRef as ReactComponent };